// mui
import { Container } from '@mui/material';

// forms
import { FormEditProgram } from '../../../../forms/FormEditProgram/FormEditProgram';

export const Program = () => {
	return (
		<Container maxWidth={false}>
			<FormEditProgram />
		</Container>
	);
};
